import PropTypes from 'prop-types';
import React from 'react';

import { Badge, Button, Select } from 'twyne-new.ui';

import Label from '../pure/rules/Label';
import RuleGroupWrapper from '../pure/rules/RuleGroup';

import Item from './Item';
import { conditionOptions, conditionsLabels } from './utils';

const propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
  groupIndex: PropTypes.number,
  onAddRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onDeleteGroup: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

export default function Group({ data, options, conditions, groupIndex, onAddRow, onDeleteRow, onDeleteGroup, onChange, disabled }) {
  const handleChangeCondition = option => {
    data.condition = option ? option.value : null
    onChange(data)
  }

  const handleChangeRow = (index, row) => {
    data.rules[index] = row
    onChange(data)
  }

  return <RuleGroupWrapper className="twy-border-base-accent">
    <div className="flex justify-between items-center mb-4">
      <div className="flex items-center gap-2">
        <Label className='whitespace-nowrap'>Match with</Label>
        <Select
          className="w-[5vw]!"
          value={data.condition}
          clearable={false}
          options={conditions?.rules || conditionOptions}
          onChange={handleChangeCondition}
          disabled={disabled}
        />
        <Label>conditions</Label>
      </div>
      <div className="flex items-center gap-2">
        {onDeleteGroup ? <Button variant='outline' size="sm" onClick={onDeleteGroup} disabled={disabled}>Delete Group</Button> : null}
        <Button variant='outline' size="sm" color="success" onClick={() => onAddRow(groupIndex)} disabled={disabled}>
          Add Condition
        </Button>
      </div>
    </div>
    {data.rules.map((rule, ruleIndex, { length }) => <React.Fragment key={ruleIndex}>
      <Item
        key={ruleIndex}
        data={rule}
        options={options}
        condition={data.condition}
        onDeleteRow={() => onDeleteRow(groupIndex, ruleIndex)}
        onChange={ruleData => handleChangeRow(ruleIndex, ruleData)}
        disabled={disabled}
      />
      {ruleIndex < length - 1 && <Badge variant='light' className='my-4 uppercase font-semibold'>{conditionsLabels[data.condition] || data.condition}</Badge>}
    </React.Fragment>,
    )}
  </RuleGroupWrapper>
}

Group.propTypes = propTypes
Group.defaultProps = {}
